import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import { api_path } from "../../shared.js";
import CampaignFormComponent from "./MainCampaignForm";
export function CampaignFormContent(props) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const [searchParams] = useSearchParams();
  const [SubjectName, setSubjectName] = useState();
  const id = searchParams.get("id");
  const [isDisabled, setDisabled] = useState(false);
  useEffect(() => {
    //run when id Change value.
    if (id > 0) {
      setSubjectName("Edit leads");
      fetch(api_path + "/TS_SALES_ORDER.php?order_id=" + id)
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
          }
        });
    } else {
      setSubjectName("Campaign");
    }
  }, [id]);
  const [value, setValue] = React.useState("1");
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid container spacing={2}>
          <br />
        </Grid>
        <Grid container spacing={2}>
          <label className="head">{SubjectName}</label>
        </Grid>
        <CampaignFormComponent
          CAMPAIGN_ID={id}
        />
      </Grid>
    </Container>
  );
}
